/* cl-ui.js — camada interativa do clone (vanilla, sem Splide/Swiper/custom elements do tema).
   - trilhos: [data-cl-track] desliza por scroll-snap; [data-cl-prev]/[data-cl-next] andam um
     item; [data-cl-dots] ganha bolinhas; [data-cl-counter] mostra "i/n"; data-cl-autoplay="ms".
   - acordeoes <details>: aria-expanded acompanha o estado real.
   - videos [data-cl-video]: clique no capa/botao toca (muted + playsinline no iPhone).
   - carrinho: icone do header e todo form /cart/add abrem a gaveta (secao cl-cart-drawer). */
(function () {
  'use strict';

  function items(track) {
    return Array.prototype.filter.call(track.children, function (c) {
      return c.nodeType === 1 && c.tagName !== 'STYLE' && c.tagName !== 'SCRIPT' && c.offsetWidth > 0;
    });
  }

  function step(track) {
    var it = items(track);
    if (it.length > 1) return Math.abs(it[1].offsetLeft - it[0].offsetLeft) || track.clientWidth;
    return track.clientWidth;
  }

  function index(track) {
    var s = step(track) || 1;
    return Math.round(track.scrollLeft / s);
  }

  function pages(track) {
    var it = items(track);
    if (!it.length) return 0;
    if (track.scrollWidth <= track.clientWidth + 2) return 1;
    // Splide em loop: uma bolinha por slide (como o tema dele)
    if (track.hasAttribute('data-cl-loop')) return it.length;
    var per = Math.max(1, Math.round(track.clientWidth / (step(track) || 1)));
    return Math.max(1, it.length - per + 1);
  }

  function go(track, i, loop) {
    var it = items(track);
    if (!it.length) return;
    var max = track.scrollWidth - track.clientWidth;
    var n = pages(track);
    if (loop) i = ((i % n) + n) % n; else i = Math.max(0, Math.min(n - 1, i));
    var left = Math.min(it[i].offsetLeft - it[0].offsetLeft, max);
    track.scrollTo({ left: left, behavior: 'smooth' });
  }

  function root(track) {
    return track.closest('[data-cl-slider]') || track.closest('[class*="cl-sec-"]') || track.parentNode;
  }

  function initTrack(track) {
    if (track.__cl) return;
    track.__cl = true;
    var r = root(track);
    var loop = track.hasAttribute('data-cl-loop');
    function bind(sel, d) {
      Array.prototype.forEach.call(r.querySelectorAll(sel), function (b) {
        if (b.closest('[data-cl-slider]') !== r && r.hasAttribute('data-cl-slider')) return;
        b.removeAttribute('disabled');
        b.addEventListener('click', function (e) { e.preventDefault(); go(track, index(track) + d, loop); });
      });
    }
    bind('[data-cl-prev]', -1);
    bind('[data-cl-next]', 1);
    var dotsBox = r.querySelector('[data-cl-dots]');
    var counter = r.querySelector('[data-cl-counter]');
    function paint() {
      var i = Math.min(index(track), pages(track) - 1);
      if (dotsBox) {
        Array.prototype.forEach.call(dotsBox.children, function (d, k) {
          var b = d.querySelector('button') || d;
          b.classList.toggle('is-active', k === i);
          b.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
      }
      if (counter) counter.textContent = (i + 1) + '/' + pages(track);
      /* bolinhas do slider-component do Shrine (galeria mobile): uma por foto */
      Array.prototype.forEach.call(r.querySelectorAll('.slider-counter__link--dots'), function (d, k) {
        d.classList.toggle('slider-counter__link--active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      var cur = r.querySelector('.slider-counter--current'), tot = r.querySelector('.slider-counter--total');
      if (cur) cur.textContent = i + 1;
      if (tot) tot.textContent = pages(track);
      track.dispatchEvent(new CustomEvent('cl:slide', { detail: { index: i } }));
      var max = track.scrollWidth - track.clientWidth;
      Array.prototype.forEach.call(r.querySelectorAll('[data-cl-prev]'), function (b) {
        if (!loop) b.disabled = track.scrollLeft <= 2;
      });
      Array.prototype.forEach.call(r.querySelectorAll('[data-cl-next]'), function (b) {
        if (!loop) b.disabled = max > 2 && track.scrollLeft >= max - 2;
      });
    }
    function buildDots() {
      if (!dotsBox) return;
      var n = pages(track);
      if (dotsBox.children.length === n) return;
      dotsBox.innerHTML = '';
      var cls = dotsBox.getAttribute('data-cl-dot-class') || 'cl-dot';
      for (var k = 0; k < n; k++) {
        var li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        var d = document.createElement('button');
        d.type = 'button'; d.className = cls;
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Go to slide ' + (k + 1));
        (function (kk) { d.addEventListener('click', function () { go(track, kk, loop); }); })(k);
        li.appendChild(d);
        dotsBox.appendChild(li);
      }
    }
    buildDots();
    Array.prototype.forEach.call(r.querySelectorAll('.slider-counter__link--dots'), function (d, k) {
      d.addEventListener('click', function (e) { e.preventDefault(); go(track, k, loop); });
    });
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick); tick = setTimeout(paint, 60);
    }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); paint(); });
    paint();

    // arrastar com o mouse no desktop (o toque ja e nativo)
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) {
      if (track.scrollWidth <= track.clientWidth + 2) return;
      down = true; moved = false; sx = e.pageX; sl = track.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('cl-dragging'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        track.classList.remove('cl-dragging');
        go(track, Math.round(track.scrollLeft / (step(track) || 1)), false);
      }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    var ms = parseInt(track.getAttribute('data-cl-autoplay') || '0', 10);
    // navegador automatizado (verify/pixel-diff): sem autoplay, a foto fica no 1o slide
    if (ms > 0 && items(track).length > 1 && !navigator.webdriver) {
      var paused = false;
      r.addEventListener('mouseenter', function () { paused = true; });
      r.addEventListener('mouseleave', function () { paused = false; });
      r.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused || document.hidden) return;
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
        else go(track, index(track) + 1, false);
      }, ms);
    }
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cl-track], [data-cl-rail]'), initTrack);
  }

  /* ---------------- acordeoes ---------------- */
  function initDetails(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[class*="cl-sec-"] details, [class*="cl-pdp-"] details'), function (d) {
      if (d.__clBound) return;
      d.__clBound = true;
      var sm = d.querySelector('summary');
      if (!sm) return;
      sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      d.addEventListener('toggle', function () { sm.setAttribute('aria-expanded', d.open ? 'true' : 'false'); });
    });
  }

  /* ---------------- abas ---------------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-cl-tab]');
    if (!tab) return;
    var box = tab.closest('[data-cl-tabs]');
    if (!box) return;
    e.preventDefault();
    var k = tab.getAttribute('data-cl-tab');
    Array.prototype.forEach.call(box.querySelectorAll('[data-cl-tab]'), function (t) {
      var on = t.getAttribute('data-cl-tab') === k;
      t.classList.toggle('is-active', on); t.classList.toggle('active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-cl-panel]'), function (p) {
      var on = p.getAttribute('data-cl-panel') === k;
      p.hidden = !on; p.classList.toggle('is-active', on); p.classList.toggle('active', on);
    });
  });

  /* ---------------- videos ---------------- */
  document.addEventListener('click', function (e) {
    var box = e.target.closest('[data-cl-video]');
    if (!box) return;
    var v = box.querySelector('video');
    if (!v) return;
    e.preventDefault();
    v.muted = false; v.playsInline = true; v.setAttribute('playsinline', '');
    if (v.paused) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-cl-video] video'), function (o) { if (o !== v) o.pause(); });
      v.play().catch(function () { v.muted = true; v.play(); });
      box.classList.add('is-playing'); v.controls = true;
    } else { v.pause(); box.classList.remove('is-playing'); }
  });

  /* ---------------- internal-video do Shrine (.ce-internal-video) ----------------
     data-autoplay="true": mudo + loop, toca com 25% visivel e pausa fora da tela (os "GIFs").
     Os demais: o botao/clique toca COM som e pausa os outros; clicar de novo pausa.
     Num autoplay com botao, o 1o clique liga o som. */
  function ivSet(box, v) {
    box.classList.toggle('internal-video--playing', !v.paused);
    box.classList.toggle('internal-video--muted', v.muted);
  }
  function ivInit(box) {
    if (box.__clIv) return;
    var v = box.querySelector('video');
    if (!v) return;
    box.__clIv = true;
    var auto = box.getAttribute('data-autoplay') === 'true';
    v.playsInline = true; v.setAttribute('playsinline', '');
    v.addEventListener('play', function () { ivSet(box, v); });
    v.addEventListener('pause', function () { ivSet(box, v); });
    v.addEventListener('volumechange', function () { ivSet(box, v); });
    if (auto) {
      v.muted = true; v.loop = true; v.setAttribute('muted', '');
      box.__clAuto = true;
    }
    ivSet(box, v);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting && x.intersectionRatio >= 0.25) {
            if (box.__clAuto && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: [0, 0.25, 0.5] }).observe(box);
    } else if (auto) { v.play().catch(function () {}); }
  }
  function initVideos(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.ce-internal-video'), ivInit);
  }
  document.addEventListener('click', function (e) {
    var box = e.target.closest('.ce-internal-video');
    if (!box) return;
    if (box.getAttribute('data-no-play-btn') === 'true' && box.__clAuto) return;
    var v = box.querySelector('video');
    if (!v) return;
    ivInit(box);
    e.preventDefault();
    if (box.__clAuto && v.muted && !v.paused) { v.muted = false; box.__clAuto = false; return; }
    if (v.paused) {
      Array.prototype.forEach.call(document.querySelectorAll('.ce-internal-video video, [data-cl-video] video'), function (o) {
        if (o !== v && !o.muted) o.pause();
      });
      v.muted = false; box.__clAuto = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
    } else { v.pause(); }
  });

  /* ---------------- carrinho ---------------- */
  function openCart(html) { document.dispatchEvent(new CustomEvent('cl:cart:open', { detail: { html: html || null, added: !!html || html === '' } })); }
  window.clOpenCart = openCart;

  document.addEventListener('click', function (e) {
    if (!document.querySelector('[data-cl-cart-drawer]')) return;
    var a = e.target.closest('a[href="/cart"], a[href$="/cart"], cart-icon, .header-actions__cart-icon, [data-cl-cart-toggle]');
    if (!a || a.closest('[data-cl-cart-drawer]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openCart();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!document.querySelector('[data-cl-cart-drawer]')) return;
    if (form.hasAttribute('data-cl-native-submit')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('.main-atc__error');
    if (err) { err.textContent = ''; err.style.display = 'none'; }
    if (btn) btn.setAttribute('aria-busy', 'true');
    /* a gaveta vem renderizada NA resposta do add (sections=): logo apos criar o carrinho a
       Section Rendering separada ainda devolve a gaveta vazia (consistencia eventual) */
    var req;
    var kit = typeof form.__clItems === 'function' ? form.__clItems() : null;
    if (kit && kit.length) {
      /* kit do widget de kits (cl-kaching.js): produto x N + brinde num POST so */
      req = fetch(form.__clKitUrl || '/cart/add.js?kaching_bundles=true', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: kit, sections: 'cl-cart-drawer', sections_url: location.pathname }) });
    } else {
      var fd = new FormData(form);
      fd.append('sections', 'cl-cart-drawer');
      fd.append('sections_url', location.pathname);
      /* ?kaching_bundles=true: o embed Kaching nao re-intercepta/mescla o add do nosso form (retrabalho 10-30) */
      req = fetch('/cart/add.js?kaching_bundles=true', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
    }
    req
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (err) { err.textContent = res.j.description || res.j.message || 'Error'; err.style.display = ''; }
          return;
        }
        var html = res.j && res.j.sections && res.j.sections['cl-cart-drawer'];
        openCart(html || '');
      })
      .catch(function () { form.setAttribute('data-cl-native-submit', ''); form.submit(); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  /* ---------------- carrossel de comentarios do app Section Store (shadow DOM sem o JS do app) ----------------
     o markup/CSS dele vem do declarative shadow DOM (mk.shadow_tokens); aqui so as setas e as bolinhas. */
  function initShadowComments() {
    Array.prototype.forEach.call(document.querySelectorAll('[class*="section-store--comments-block"]'), function (host) {
      var sr = host.shadowRoot;
      if (!sr || host.__clSc) return;
      var inner = sr.querySelector('.comment-list.carousel .comment-list-inner');
      if (!inner) return;
      host.__clSc = true;
      var cards = function () { return Array.prototype.filter.call(inner.children, function (c) { return c.classList.contains('comment'); }); };
      var dots = Array.prototype.slice.call(sr.querySelectorAll('.slide-dots .dot'));
      function idx() { var w = inner.clientWidth || 1; return Math.round(inner.scrollLeft / w); }
      function go(i) {
        var n = cards().length;
        if (!n) return;
        i = ((i % n) + n) % n;
        inner.scrollTo({ left: i * inner.clientWidth, behavior: 'smooth' });
        paint(i);
      }
      function paint(i) { dots.forEach(function (d, k) { d.classList.toggle('active', k === i); }); }
      var prev = sr.querySelector('.navigation .prev'), next = sr.querySelector('.navigation .next');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(idx() - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(idx() + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var t;
      inner.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { paint(idx()); }, 80); }, { passive: true });
    });
  }

  /* ---------------- dynamic-dates do Shrine (prazo de entrega) ----------------
     data-text com [start_date]/[end_date]; hoje + min/max dias; formato mm_dd = "Mes 31st" (como o main.js dele) */
  function suf(d) { return (d === 1 || d === 21 || d === 31) ? 'st' : (d === 2 || d === 22) ? 'nd' : (d === 3 || d === 23) ? 'rd' : 'th'; }
  function initDates(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.ce-dynamic-dates'), function (box) {
      var months = (box.getAttribute('data-month-labels') || '').split(',').map(function (x) { return x.trim(); });
      var days = (box.getAttribute('data-day-labels') || '').split(',').map(function (x) { return x.trim(); });
      var fmt = box.getAttribute('data-date-format') || 'mm_dd';
      Array.prototype.forEach.call(box.querySelectorAll('[data-dynamic-date="true"]'), function (el) {
        function at(n) {
          var d = new Date(); d.setDate(d.getDate() + n);
          if (fmt === 'day_dd_mm') return days[(d.getDay() + 6) % 7] + ', ' + d.getDate() + '. ' + months[d.getMonth()];
          if (fmt === 'dd_mm') return d.getDate() + '. ' + months[d.getMonth()];
          return months[d.getMonth()] + ' ' + d.getDate() + suf(d.getDate());
        }
        var t = el.getAttribute('data-text') || '';
        el.innerHTML = t.replace('[start_date]', ' ' + at(parseInt(el.getAttribute('data-min-days'), 10) || 0))
                        .replace('[end_date]', ' ' + at(parseInt(el.getAttribute('data-max-days'), 10) || 0));
      });
    });
  }

  /* ---------------- menu do header inteiro na tela (pedido do operador 10-26) ----------------
     o overflow-list do Horizon joga o excesso no "Mas"; showAll() (API publica dele) devolve tudo ao slot
     visivel e o desliga (disabled); reaplica se um reflow mexer de novo. A quebra em 2 linhas e do cl-global.css.
     O reflow dele, com a lista quebrando, conta poucos itens "visiveis" e dispara overflowMinimum -> o header vai
     para a gaveta (hamburguer). Igual ao concorrente: >=990px o menu fica SEMPRE inteiro na tela (quebra em quantas
     linhas precisar, 3 entre 990 e 1280); 750-989 e gaveta (no lugar do "Mas"). Reavalia no resize. */
  function initMenu() {
    if (!window.customElements) return;
    customElements.whenDefined('overflow-list').then(function () {
      Array.prototype.forEach.call(document.querySelectorAll('header-menu overflow-list'), function (el) {
        if (el.__clAll) return;
        el.__clAll = true;
        var mine = false;
        var tell = function (hide) {
          if (hide) el.setAttribute('minimum-reached', ''); else el.removeAttribute('minimum-reached');
          mine = true;
          el.dispatchEvent(new CustomEvent('overflowMinimum', { bubbles: true, detail: { minimumReached: hide } }));
          mine = false;
        };
        var busy = false, again = false;
        var settle = function () {
          if (typeof el.showAll !== 'function' || !window.matchMedia('(min-width: 750px)').matches) return;
          if (busy) { again = true; return; }
          busy = true; again = false;
          try { el.showAll(); } catch (e) {}
          var wide = window.matchMedia('(min-width: 990px)').matches;
          tell(!wide);
          requestAnimationFrame(function () {
            busy = false;
            if (again) settle();
          });
        };
        new MutationObserver(function (ms) {
          for (var i = 0; i < ms.length; i++) { if (ms[i].target.getAttribute('slot') === 'overflow') { settle(); return; } }
        }).observe(el, { subtree: true, attributes: true, attributeFilter: ['slot'] });
        el.addEventListener('overflowMinimum', function (e) { if (!mine && e.detail && e.detail.minimumReached) setTimeout(settle, 0); });
        var rt = null;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(settle, 150); });
        settle();
      });
    });
  }

  function boot() { initDates(); initAll(); initDetails(); initVideos(); initShadowComments(); initMenu(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.clInitTracks = function (s) { initAll(s); initDetails(s); initVideos(s); };
})();
